// extracted by mini-css-extract-plugin
export default {"birthYearModal":"BirthYearModal_birthYearModal__A2dcm","label":"BirthYearModal_label__oWFmf","input":"BirthYearModal_input__Rw3Tx"};